const TimeoutDelay = {
  Default: 500,
  HeightUpToBottom: 300,
};

export const RegAnalyticsConstants = {
  TimeoutDelay,
};
